import { useContext } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import AppContext from "../../../AppContext";
import { IScheduleSlot } from "../../../Calendar/types/ICalendar";
import IReservation from "../../../types/IReservation";
import useCreateReservation from "../hooks/useCreateReservation";

/**
 * A hook which creates a reservation for the given {@link IScheduleSlot} using the appropriate calendar process for
 * the input, and is controlled by the {@link AppContext}.
 */
const AppContextUseCreateReservation: TriggeredHook<IReservation, IScheduleSlot, boolean> = () => {
  const { bookingController, patient, contactId } = useContext(AppContext);
  if (!bookingController?.selected) throw "Must have a service to release a block.";
  return useCreateReservation({
    contactId: contactId,
    service: bookingController.selected.schedule.service,
    patientId: patient.id,
    center: bookingController.selected.center
  });
};

export default AppContextUseCreateReservation;
